var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from "react";
import Flex from "./Flex";
var Stack = function Stack(props) {
  return React.createElement(Flex, _extends({
    column: true
  }, props));
};
export default Stack;